/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recognition_Top_Rated_NoteInputs */

const en_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consistent high-quality delivery & client satisfaction`)
};

const ar_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم عالي الجودة باستمرار ورضا العملاء`)
};

const bn_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্থিরভাবে উচ্চ-মানের ডেলিভারি ও ক্লায়েন্ট সন্তুষ্টি`)
};

const de_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichbleibend hochwertige Lieferung und Kundenzufriedenheit`)
};

const es_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega consistente de alta calidad y satisfacción del cliente`)
};

const fr_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison constante de haute qualité et satisfaction du client`)
};

const pt_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega consistente de alta qualidade e satisfação do cliente`)
};

const zh_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始终如一的高质量交付和客户满意度`)
};

const tr_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutarlı yüksek kaliteli iş teslimi ve müşteri memnuniyeti`)
};

const ru_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стабильно высокое качество доставки и удовлетворенность клиентов`)
};

const pl_recognition_top_rated_note = /** @type {(inputs: Recognition_Top_Rated_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stale wysoka jakość realizacji i zadowolenie klientów`)
};

/**
* | output |
* | --- |
* | "Consistent high-quality delivery & client satisfaction" |
*
* @param {Recognition_Top_Rated_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const recognition_top_rated_note = /** @type {((inputs?: Recognition_Top_Rated_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recognition_Top_Rated_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_recognition_top_rated_note(inputs)
	if (locale === "bn") return bn_recognition_top_rated_note(inputs)
	if (locale === "de") return de_recognition_top_rated_note(inputs)
	if (locale === "es") return es_recognition_top_rated_note(inputs)
	if (locale === "fr") return fr_recognition_top_rated_note(inputs)
	if (locale === "pt") return pt_recognition_top_rated_note(inputs)
	if (locale === "zh") return zh_recognition_top_rated_note(inputs)
	if (locale === "tr") return tr_recognition_top_rated_note(inputs)
	if (locale === "ru") return ru_recognition_top_rated_note(inputs)
	if (locale === "pl") return pl_recognition_top_rated_note(inputs)
	return en_recognition_top_rated_note(inputs)
});